import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './sass/style.scss';
import './sass/custom.scss';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDCZU7r4vtMaeFabUHQRQvYvCgwospnif4",
  authDomain: "apeaceofmind.firebaseapp.com",
  projectId: "apeaceofmind",
  storageBucket: "apeaceofmind.appspot.com",
  messagingSenderId: "1096592989797",
  appId: "1:1096592989797:web:7e32d057929b9c66b9708c",
  measurementId: "G-VRV955G6M6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
